import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/**
 * The collapsed create/edit order drawer.
 *
 * Sits over the chat so the operator can ask the client a question without
 * losing what they already filled in, and reads as parked work rather than a
 * notification — the whole body is the restore control.
 */
@Component({
  selector: 'op-order-draft-pill',
  imports: [MatIconModule],
  templateUrl: './order-draft-pill.component.html',
  styleUrl: './order-draft-pill.component.scss',
})
export class OrderDraftPillComponent {
  /** What is parked, e.g. "Editing ORD-00042". */
  @Input({ required: true }) label = '';
  /** Drives the discard copy: unsaved work warns before it goes. */
  @Input() dirty = false;

  @Output() resume = new EventEmitter<void>();
  @Output() discard = new EventEmitter<void>();
}
